module.exports = __webpack_public_path__ + "static/logo-7b1a7039d55f817245f63fff15410959.png";